import React from 'react';
import { Navbar } from '../../../components/navbar/Navbar';
import BackButton from '../../../components/button/BackButton';
import Label from '../../../components/title/label';
import DateFormatConverter from '../../../components/input/DateFormatConvert';

function VoirDetailRecetteResteRecouvrer() {
  // Contenu de la barre de navigation
  const NavbarContent = (
    <div className='flex justify-between'>
      <div className='text-white font-semibold'>
       Voir détail recette Reste à Recouvrer
      </div>
      <div>
        <BackButton to="/VisualisationResteRecouvrer"></BackButton>
      </div>
    </div>
  );

  const Recette = localStorage.getItem("selectedDataReesteRecouvrer");
  const recepisse = JSON.parse(Recette);

  console.log(recepisse);
  
  return (
    <div className='bg-[#212122] h-screen w-full'>
      <Navbar content={NavbarContent}></Navbar>
      <div className='flex justify-center'>
        <div className='flex flex-col w-[400px] h-[200px] mt-8'>
          <Label text="Raison sociale" className="font-semibold m-2"></Label>
          <Label text="Activité" className="font-semibold m-2"></Label>
          <Label text="Adresse" className="font-semibold m-2"></Label>
          <Label text="Commune" className="font-semibold m-2"></Label>
          <Label text="Nature Impôt" className="font-semibold m-2"></Label>
          <Label text="Numéro Impot" className="font-semibold m-2"></Label>
          <Label text="Référence fiscale" className="font-semibold m-2"></Label>
          <Label text="Numéro recepissé" className="font-semibold m-2"></Label>
          <Label text="Type de payment" className="font-semibold m-2"></Label>
          <Label text="Période" className="font-semibold m-2"></Label>
          <Label text="Période 1" className="font-semibold m-2"></Label>
          <Label text="Période 2" className="font-semibold m-2"></Label>
          <Label text="Montant verser" className="font-semibold m-2"></Label>
          <Label text="Montant à payer" className="font-semibold m-2"></Label>
          <Label text="Reste à payer" className="font-semibold m-2"></Label>
          <Label text="Date de payment" className="font-semibold m-2"></Label>
        </div>
        <div className='flex flex-col w-[400px] h-[200px] mt-8'>
          <Label text={recepisse?.raison_social || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.activite || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.adresse || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.commune || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.base_impot || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.numero_impot || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.reference_fiscal || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.numero_recepisse || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.type_payment || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode1 || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.periode2 || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.montant_verser || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.montant_a_payer || "aucune"} className="font-semibold m-2"></Label>
          <Label text={recepisse?.reste_a_payer || "aucune"} className="font-semibold m-2"></Label>
          <DateFormatConverter isoDate={recepisse?.date_creation || "aucune"} className="font-semibold text-white m-2"></DateFormatConverter>
        </div>
      </div>
    </div>
  );
}

export default VoirDetailRecetteResteRecouvrer;
